<template>
  <v-tooltip 
    v-if="isAdmin" 
    right
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        v-on="on" 
        class='ma-2' 
        color="primary" 
        v-clipboard:copy="copyTokenString" 
        v-clipboard:success="handleSuccess" 
        v-clipboard:error="handleError"
      >
        Copy API Token
      </v-btn>
    </template>
    An API token is required to access the Qumulex Portal API
  </v-tooltip>
</template>

<script>

export default {
  name: "HelpDialogTooltip",
  props: [
    "isAdmin",
    "isLoggedIn",
    "tokenString"
  ],

  computed: {
    copyTokenString() { 
      return this.isLoggedIn ? this.tokenString : "No logged in user"
    }
  },

  methods: {
    handleSuccess(e) {
      console.log("Clipboard Success: ")
      console.log(e)
    },
    handleError(e) {
      console.error("Clipboard Error: ")
      console.log(e)
    }
  }
}
</script>